import React, {useState} from "react";
import {Columns, Modal, Section, Form, Button, Heading} from "react-bulma-components";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";


export default function CreateCreditNoteModal({autoFill, endpoint, dataFresh, open, setOpen}){
    const [credit, setCredit] = useState({});
    const dispatch = useDispatch();

    const onChange = e => {
        let newCredit = {...credit, [e.target.name]: e.target.value};
        setCredit(newCredit);
    }


    const onSave = (data) => {
       if(autoFill.transaction){
           data.transaction = autoFill.transaction
       }
       else if(autoFill.invoice){
           data.invoice = autoFill.invoice
       }
       else if(autoFill.work){
           data.work = autoFill.work
       }
       else if(autoFill.part){
           data.part = autoFill.part
       }

       const conf = {
           url: endpoint + "credit",
           method: "post",
           data: data
       };
       axios(conf).then(res => {
           dispatch(createSetDataFreshAction(dataFresh + 1));
           setOpen(false);
       })
    }


    return (
        <Modal
            show={open}
            onClose={() =>{
                setCredit({})
                setOpen(false);
            }}
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Create Credit Note</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Customer Name</Form.Label>
                            <Form.Input
                                type={"text"}
                                value={autoFill.customer.display_name ?? autoFill.customer}
                                disabled={true}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Amount (£)</Form.Label>
                            <Form.Input
                                name={"amount"}
                                type={"number"}
                                value={credit.amount}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Non Vat Amount (£)</Form.Label>
                            <Form.Input
                                name={"no_vat_amount"}
                                type={"number"}
                                value={credit.no_vat_amount}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Date Issued</Form.Label>
                            <Form.Input
                                name={"date_issued"}
                                type={"date"}
                                value={credit.date}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Credit Note Number</Form.Label>
                            <Form.Input
                                type={"text"}
                                name={"credit_note_number"}
                                onChange={onChange}
                                value={credit.credit_note_number}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Description</Form.Label>
                            <Form.Textarea
                                name={"description"}
                                value={credit.description}
                                onChange={onChange}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                onClick={() => {
                                    onSave(credit);
                                }}
                                color={"success"}
                                fullwidth
                            >
                                Create
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={()=> {
                                    setCredit({});
                                    setOpen(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )



}